import { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES, SYSTEM_VIEW, ORDER_TYPES } from "const";
import styles from "./QuickSaleButtons.module.css";
import SalesContext from "context/SalesContext";
import SearchContext from "context/SearchContext";
import NewOrderImg from "images/svg/NewSale.svg";
import TakeAwayImg from "images/svg/TakeAway.svg";
import DeliveryImg from "images/svg/Delivery.png";
import NonChargeableImg from "images/svg/NonChargable.svg";
import * as TerminalHelper from "helpers/TermialHelper";

const ICONS = {
  [ORDER_TYPES.TAKE_AWAY]: TakeAwayImg,
  [ORDER_TYPES.DELIVERY]: DeliveryImg,
  [ORDER_TYPES.NC]: NonChargeableImg,
};

const QuickSaleButtons = ({ height = null }) => {
  const navigate = useNavigate();
  const { activeSale, handleSaveDraftSale, handleClearActiveSale, createNewSoftSale, createNewSale } =
    useContext(SalesContext);
  const { setSearchTerm } = useContext(SearchContext);

  const orderTypes = useMemo(() => {
    return TerminalHelper.loadOrderTypesFromStorage().slice(0, 3);
  }, []);

  const handleCreateNewSale = async (orderType) => {
    if (setSearchTerm) setSearchTerm("");

    try {
      if (activeSale?.items?.length > 0) {
        if (activeSale?.editing_sale_local_id) {
          await handleClearActiveSale();
        } else {
          await handleSaveDraftSale({}, true);
        }
      } else {
        await handleClearActiveSale();
      }
    } catch (err) {
      console.error("Failed to clear active sale or save draft during new sale creation:", err);
    }

    const saleData = {
      order_type: orderType,
    };

    const terminalSettings = TerminalHelper.getTerminalSettings();
    if (terminalSettings?.systemType === SYSTEM_VIEW.ERP) {
      await createNewSale(saleData);
      navigate(ROUTES.ERP_DASHBOARD);
    } else {
      createNewSoftSale(saleData);
      navigate(ROUTES.SALES);
    }
  };

  const visibleButtons = useMemo(() => {
    const orderTypeButtons = orderTypes.map((orderType) => ({
      key: orderType,
      label: orderType,
      icon: ICONS[orderType] || NewOrderImg,
      color: "#2B2B2B",
    }));

    return [{ key: null, label: "New Sale", icon: NewOrderImg, color: "#2B2B2B" }, ...orderTypeButtons];
  }, [orderTypes]);

  return (
    <div className={styles.container} style={{ height: height || "100%" }}>
      {visibleButtons.map((btn, index) => (
        <div
          key={index}
          className={`${styles.button} ${visibleButtons.length % 2 !== 0 && visibleButtons.length > 1 && index === 0 ? styles.spanTwo : ""}`}
          onClick={() => handleCreateNewSale(btn.key)}
          role="button"
          tabIndex={0}
        >
          <img src={btn.icon} alt={btn.label} className={styles.icon} />
          <span className={styles.label}>{btn.label}</span>
        </div>
      ))}
    </div>
  );
};

export default QuickSaleButtons;
